import SgdsMasthead from "@govtechsg/sgds-web-component/react/masthead/index.js"
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';

const MastHeadContainer = styled(Container)({
    paddingLeft: '0px !important',
    paddingRight: '0px !important',
    maxWidth: '100%',
    overflow: 'hidden'
});

function MerLionHeader() {
    return (
        <div style={{ backgroundColor: 'hsl(0, 0%, 94%)', paddingLeft: '0rem', paddingRight: '0rem' }}>
            <MastHeadContainer>
                <SgdsMasthead></SgdsMasthead>
            </MastHeadContainer>
        </div>
    );
}

export default MerLionHeader;
